import { z } from 'zod';

export const placeholdersSchema = z.record(z.string()).nullable();

export const basicResponseSchema = z.object({
	action: z.enum(['Redirect', 'Display']),
	flow: z.object({
		flowId: z.string(),
		contentId: z.string().nullable(),
		channel: z.string(),
		lang: z.string(),
	}),
	placeholders: placeholdersSchema,
	statusCode: z.number(),
	xsrfToken: z.string().nullable(),
	redirectUrl: z.string().nullable(),
});
